import React, { useRef, useState } from "react";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import {
  Button,
  ButtonGroup,
  ClickAwayListener,
  Grow,
  MenuItem,
  MenuList,
  Paper,
  Popper,
  Tooltip
} from "@mui/material";
import { ConfirmDialog } from "app/components";
const Dropdown = (props) => {
  const { className, options, defaultSelectedIndex = 1 } = props;
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [open, setOpen] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(defaultSelectedIndex);
  const anchorRef = useRef(null);
  function handleClick() {
    setConfirmOpen(true);
  }
  function handleMenuItemClick(event, index) {
    setSelectedIndex(index);
    setConfirmOpen(true);
    setOpen(false);
  }
  function handleToggle() {
    setOpen((prevOpen) => !prevOpen);
  }
  function handleClose(event) {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpen(false);
  }
  return /* @__PURE__ */ React.createElement("div", { className }, /* @__PURE__ */ React.createElement(
    ConfirmDialog,
    {
      title: options[selectedIndex].confirmDialog.title,
      open: confirmOpen,
      setOpen: setConfirmOpen,
      onConfirm: options[selectedIndex].action
    },
    options[selectedIndex].confirmDialog.message
  ), /* @__PURE__ */ React.createElement(ButtonGroup, { ref: anchorRef, "aria-label": "Split button" }, /* @__PURE__ */ React.createElement(Tooltip, { title: options[selectedIndex].disabled ? options[selectedIndex].tooltip : "" }, /* @__PURE__ */ React.createElement(
    Button,
    {
      variant: "contained",
      sx: {
        borderTopRightRadius: 0,
        borderBottomRightRadius: 0,
        boxShadow: "unset"
      },
      onClick: handleClick,
      disabled: options[selectedIndex].disabled,
      "data-testid": options[selectedIndex].testId || "dropdown-main-button"
    },
    options[selectedIndex].title
  )), /* @__PURE__ */ React.createElement(
    Button,
    {
      sx: {
        borderTopLeftRadius: 0,
        borderBottomLeftRadius: 0
      },
      size: "small",
      "aria-owns": open ? "menu-list-grow" : void 0,
      "aria-haspopup": "true",
      onClick: handleToggle,
      "data-testid": options[selectedIndex].toggleTestId || "dropdown-toggle-button"
    },
    /* @__PURE__ */ React.createElement(ArrowDropDownIcon, null)
  )), /* @__PURE__ */ React.createElement(Popper, { sx: { zIndex: 1 }, open, anchorEl: anchorRef.current, transition: true }, ({ TransitionProps, placement }) => /* @__PURE__ */ React.createElement(
    Grow,
    {
      ...TransitionProps,
      style: {
        transformOrigin: placement === "bottom" ? "center top" : "center bottom"
      }
    },
    /* @__PURE__ */ React.createElement(Paper, { elevation: 1, id: "menu-list-grow" }, /* @__PURE__ */ React.createElement(ClickAwayListener, { onClickAway: handleClose }, /* @__PURE__ */ React.createElement(MenuList, null, options.map((option, index) => /* @__PURE__ */ React.createElement(Tooltip, { key: option.title, title: options[index].disabled ? options[index].tooltip : "" }, /* @__PURE__ */ React.createElement(
      MenuItem,
      {
        key: option.title,
        disabled: options[index].disabled,
        selected: index === selectedIndex,
        onClick: (event) => handleMenuItemClick(event, index),
        "data-testid": options[index].testId || `dropdown-menu-item-${index}`
      },
      option.title
    ))))))
  )));
};
export default Dropdown;
